import { render, staticRenderFns } from "./TabBudgetActivities.vue?vue&type=template&id=8269859a&scoped=true"
import script from "./TabBudgetActivities.vue?vue&type=script&lang=ts"
export * from "./TabBudgetActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8269859a",
  null
  
)

export default component.exports